webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff04090_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(39);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(38)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ff04090"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff04090_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ls__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_min_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_dist_theme_default_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_dist_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_material_dist_theme_default_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










var options = {
  namespace: 'autocar__'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_ls___default.a, options);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["default"] },
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App__["default"]);
  },
  created: function created() {
    this.ValidateCredential();
  },

  computed: {
    firstDayOfAWeek: {
      get: function get() {
        return this.$material.locale.firstDayOfAWeek;
      },
      set: function set(val) {
        this.$material.locale.firstDayOfAWeek = val;
      }
    }
  },
  name: 'TableFixed',
  data: function data() {
    return {
      global: {
        // webApi: 'https://localhost:44331/',
        webApi: 'https://dswebapi.duesoft.com.br/',
        menuVisible: false,
        menuAcoesVisible: false,
        menuAcoesShow: false,
        sending: false,
        dialogVisible: false,
        dialogMessage: '',
        logged: false,
        recuperaSenhaVisible: false,
        alteraSenhaVisible: false,
        activeRoute: '',
        enterControl: '',
        schema: 'Autocar'
      },
      user: {
        cnpj: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('usr'),
        name: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('name'),
        password: null,
        newPassword: null,
        confirmNewPassword: null,
        company: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('cpn'),
        auth: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('cdt'),
        saved: false,
        logo: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('logo'),
        email: null
      },
      home: {
        visible: false,
        acoesVisible: false
      },
      login: {
        visible: true,
        acoesVisible: false,
        companies: [],
        lastUser: null,
        validId: false
      },
      paginacao: {
        visible: false,
        pagina: 1,
        totalPaginas: 1
      },
      produtos: {
        visible: false,
        promocao: false,
        acoesVisible: true,
        itens: [],
        imagemPrincipal: null,
        detalhe: {
          menuTitle: 'Geral',
          item: null,
          visible: false
        },
        pesquisa: {
          visible: false,
          filtrados: [],
          codigoEmpresaOriginalSimilarSrc: null,
          descSrc: null,
          lancSrc: null
        }
      },
      produtosLanc: {
        showLanc: true,
        visible: false,
        acoesVisible: true,
        itens: [],
        imagemPrincipal: null,
        detalhe: {
          menuTitle: 'Geral',
          item: null,
          visible: false
        },
        pesquisa: {
          visible: false,
          filtrados: [],
          codigoEmpresaOriginalSimilarSrc: null,
          descSrc: null,
          lancSrc: null
        }
      },
      produtosPromocao: {
        visible: false,
        acoesVisible: true,
        itens: [],
        imagemPrincipal: null,
        detalhe: {
          menuTitle: 'Geral',
          item: null,
          visible: false
        },
        pesquisa: {
          visible: false,
          filtrados: [],
          codigoEmpresaOriginalSimilarSrc: null,
          descSrc: null,
          lancSrc: null
        }
      },
      carrinho: {
        visible: false,
        acoesVisible: true,
        inputQtd: {
          visible: false,
          item: { stock: 0.00 },
          qtd: 0.00
        },
        editQtd: {
          visible: false,
          item: { stock: 0.00 },
          qtd: 0.00
        },
        itens: [],
        detalhe: {
          visible: false,
          total: 0.00
        }
      },
      historicoFinanceiro: {
        visible: false,
        acoesVisible: true,
        itens: [],
        pesquisa: {
          visible: false,
          dtVencIni: null,
          dtVencFin: null,
          dtPicker1: 0,
          dtPicker2: 1
        }
      },
      pedidos: {
        visible: false,
        acoesVisible: true,
        pesquisa: {
          visible: false,
          initialDateSrc: null,
          finalDateSrc: null,
          statusSrc: [],
          status: []
        },
        itens: [],
        detalhe: {
          item: {
            company: null,
            solicitationNumber: null,
            orderNumber: null,
            status: null,
            orderDate: '',
            totalPrice: null,
            itens: []
          },
          visible: false
        }
      },
      fornecedores: {
        visible: false,
        acoesVisible: false,
        images: []
      },
      configuracoes: {
        visible: false,
        acoesVisible: false
      },
      update: {
        updating: false,
        produtosToUpdate: true,
        grayScreen: false
      }
    };
  },
  methods: {
    Logoff: function Logoff() {
      this.ClearCredential();
      this.GerenciarNavegacao('login');
    },
    MaskDateVenctoIni: function MaskDateVenctoIni() {
      if (this.historicoFinanceiro.pesquisa.dtVencIni === null || this.historicoFinanceiro.pesquisa.dtVencIni === undefined) {
        return;
      }

      while (this.historicoFinanceiro.pesquisa.dtVencIni.includes('/')) {
        this.historicoFinanceiro.pesquisa.dtVencIni = this.historicoFinanceiro.pesquisa.dtVencIni.replace('/', '');
      }

      if (this.historicoFinanceiro.pesquisa.dtVencIni.length > 2) {
        this.historicoFinanceiro.pesquisa.dtVencIni = this.historicoFinanceiro.pesquisa.dtVencIni.substring(0, 2) + '/' + this.historicoFinanceiro.pesquisa.dtVencIni.substring(2);
      }

      if (this.historicoFinanceiro.pesquisa.dtVencIni.length > 5) {
        this.historicoFinanceiro.pesquisa.dtVencIni = this.historicoFinanceiro.pesquisa.dtVencIni.substring(0, 5) + '/' + this.historicoFinanceiro.pesquisa.dtVencIni.substring(5);
      }

      if (this.historicoFinanceiro.pesquisa.dtVencIni.length > 10) {
        this.historicoFinanceiro.pesquisa.dtVencIni = this.historicoFinanceiro.pesquisa.dtVencIni.substring(0, 10);
      }
    },
    MaskDateVenctoFin: function MaskDateVenctoFin() {
      if (this.historicoFinanceiro.pesquisa.dtVencFin === null || this.historicoFinanceiro.pesquisa.dtVencFin === undefined) {
        return;
      }

      while (this.historicoFinanceiro.pesquisa.dtVencFin.includes('/')) {
        this.historicoFinanceiro.pesquisa.dtVencFin = this.historicoFinanceiro.pesquisa.dtVencFin.replace('/', '');
      }

      if (this.historicoFinanceiro.pesquisa.dtVencFin.length > 2) {
        this.historicoFinanceiro.pesquisa.dtVencFin = this.historicoFinanceiro.pesquisa.dtVencFin.substring(0, 2) + '/' + this.historicoFinanceiro.pesquisa.dtVencFin.substring(2);
      }

      if (this.historicoFinanceiro.pesquisa.dtVencFin.length > 5) {
        this.historicoFinanceiro.pesquisa.dtVencFin = this.historicoFinanceiro.pesquisa.dtVencFin.substring(0, 5) + '/' + this.historicoFinanceiro.pesquisa.dtVencFin.substring(5);
      }

      if (this.historicoFinanceiro.pesquisa.dtVencFin.length > 10) {
        this.historicoFinanceiro.pesquisa.dtVencFin = this.historicoFinanceiro.pesquisa.dtVencFin.substring(0, 10);
      }
    },
    ExibirDetalheProduto: function ExibirDetalheProduto(produto) {
      this.produtos.detalhe.code = produto.code;
      this.produtos.detalhe.productGroup = produto.productGroup;
      this.produtos.detalhe.productSubgroup = produto.productSubgroup;
      this.produtos.detalhe.description = produto.description;
      this.produtos.detalhe.completeDescription = produto.completeDescription;
      console.log(produto.completeDescription);
      this.produtos.detalhe.unity = produto.unity;
      this.produtos.detalhe.stock = parseFloat(produto.stock.toFixed(6));
      this.produtos.detalhe.price = produto.price;
      this.produtos.detalhe.observations = produto.observations;
      this.produtos.detalhe.applications = produto.applications;
      this.produtos.detalhe.originalCodes = produto.originalCodes;
      this.produtos.detalhe.similar = produto.similar;
      this.produtos.detalhe.images = produto.images;
      this.produtos.detalhe.marcaPecaProduto = produto.marcaPecaProduto;

      this.produtos.detalhe.visible = true;
      this.update.updating = false;
    },
    CloseInfoProd: function CloseInfoProd() {
      this.produtos.detalhe.visible = false;
      this.update.updating = false;
    },
    ShowDialog: function ShowDialog(message) {
      this.global.dialogMessage = message;
      this.global.dialogVisible = true;
    },
    GerenciarNavegacao: function GerenciarNavegacao(rota) {
      this.global.menuVisible = false;
      this.global.menuAcoesVisible = false;
      this.global.menuAcoesShow = false;
      this.global.alteraSenhaVisible = false;
      this.login.visible = false;
      this.home.visible = false;
      this.produtos.visible = false;
      this.produtosLanc.visible = false;
      this.historicoFinanceiro.visible = false;
      this.carrinho.visible = false;
      this.pedidos.visible = false;
      this.fornecedores.visible = false;
      this.configuracoes.visible = false;
      this.paginacao.visible = false;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set('activeRoute', rota);

      switch (rota) {
        case 'login':
          this.global.activeRoute = 'Catálogo Online';
          this.login.visible = true;
          break;

        case 'home':
          this.global.activeRoute = 'Início';
          this.global.menuAcoesVisible = this.home.acoesVisible;
          this.home.visible = true;
          break;

        case 'produtos_lancamentos':
          this.global.activeRoute = 'Lançamentos';
          this.global.menuAcoesVisible = this.produtosLanc.acoesVisible;
          this.CarregarTelaDeLancamentos();
          break;

        case 'produtos':
          this.global.activeRoute = 'Produtos';
          this.global.menuAcoesVisible = this.produtos.acoesVisible;
          this.LimparFiltrosPesquisaProdutos();
          this.CarregarTelaDeProdutos();
          break;

        case 'produtos_promocao':
          this.global.activeRoute = 'Produtos Promoção';
          this.global.menuAcoesVisible = this.produtos.acoesVisible;
          this.LimparFiltrosPesquisaProdutos();
          this.CarregarTelaDeProdutosPromocao();
          break;

        case 'carrinho':
          this.global.activeRoute = 'Meu Carrinho';
          this.carrinho.itens = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get(this.user.company + '_carrinho');
          this.global.menuAcoesVisible = this.carrinho.acoesVisible;
          this.carrinho.visible = true;
          break;

        case 'historico_financeiro':
          this.global.activeRoute = 'Relatório Financeiro';
          this.global.menuAcoesVisible = this.historicoFinanceiro.acoesVisible;
          this.CarregarTelaDeHistoricoFinanceiro();
          break;

        case 'pedidos':
          this.global.activeRoute = 'Meus Pedidos';
          this.global.menuAcoesVisible = this.pedidos.acoesVisible;
          this.CarregarTelaDePedidos();
          break;

        case 'fornecedores':
          this.global.activeRoute = 'Fornecedores';
          this.global.menuAcoesVisible = this.fornecedores.acoesVisible;
          this.CarregarTelaDeFornecedores();
          break;

        case 'configuracoes':
          this.global.activeRoute = 'Configurações';
          this.global.menuAcoesVisible = this.configuracoes.acoesVisible;
          this.configuracoes.visible = true;
          break;

        default:
          this.global.activeRoute = 'Lançamentos';
          this.global.menuAcoesVisible = this.produtosLanc.acoesVisible;
          this.CarregarTelaDeLancamentos();
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set('activeRoute', 'produtos_lancamentos');
          this.global.activeRoute = 'Lançamentos';
      }
    },
    Redirecionar: function Redirecionar(rota) {
      this.global.menuVisible = false;
      this.global.menuAcoesVisible = false;
      this.global.menuAcoesShow = false;
      this.login.visible = false;
      this.home.visible = false;
      this.produtos.visible = false;
      this.produtosLanc.visible = false;
      this.historicoFinanceiro.visible = false;
      this.carrinho.visible = false;
      this.pedidos.visible = false;
      this.fornecedores.visible = false;
      this.configuracoes.visible = false;
      this.paginacao.visible = false;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set('activeRoute', rota);

      switch (rota) {
        case 'produtos':
          this.global.activeRoute = 'Produtos';
          this.global.menuAcoesVisible = this.produtos.acoesVisible;
          this.paginacao.visible = false;
          this.produtos.visible = true;
          this.paginacao.pagina = 1;
          this.ExibirProdutos('<', false, false);
          this.update.updating = false;
          break;
      }
    },
    ObterEmpresas: function ObterEmpresas() {
      var _this = this;

      this.global.sending = true;
      this.user.company = null;
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetCompanies?id=' + this.user.cnpj + '&schema=' + this.global.schema
      }).then(function (response) {
        if (response.status === 200) {
          _this.login.companies = response.data;
          _this.login.validId = true;
          _this.global.sending = false;
        } else {
          _this.login.validId = false;
          _this.ShowDialog('Nenhuma empresa vinculada a esse CNPJ.');
          _this.global.sending = false;
        }
      }).catch(function (e) {
        _this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor!');
        _this.global.sending = false;
      });
    },
    EfetuarLogin: function EfetuarLogin() {
      var _this2 = this;

      this.global.sending = true;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/UserLogin',
        data: {
          User: this.user.cnpj,
          Password: this.user.password,
          Company: this.user.company,
          Schema: this.global.schema
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this2.user.name = response.data.userName;
          _this2.user.auth = response.data.authorization;
          _this2.user.logo = response.data.logo;
          _this2.logged = true;
          _this2.saveUser();
          _this2.GerenciarNavegacao('produtos_lancamentos');
          _this2.global.sending = false;
        } else {
          _this2.ClearCredential();
          _this2.GerenciarNavegacao('login');
          _this2.ShowDialog('Não foi possível efetuar a autenticação. Reveja seu login e senha ou entre em contato com seu fornecedor.');
          _this2.global.sending = false;
        }
      }).catch(function (e) {
        _this2.ClearCredential();
        _this2.GerenciarNavegacao('login');
        _this2.ShowDialog('Não foi possível efetuar a autenticação. Reveja seu login e senha ou entre em contato com seu fornecedor.');
        _this2.global.sending = false;
      });
    },
    CarregarTelaDeProdutos: function CarregarTelaDeProdutos() {
      this.paginacao.visible = false;
      this.produtos.visible = true;
      this.produtos.promocao = false;
      this.paginacao.pagina = 1;
      this.ExibirProdutos('<', false, false);
      this.update.updating = false;

      this.AbrirTelaDePesquisa();
    },
    CarregarTelaDeProdutosPromocao: function CarregarTelaDeProdutosPromocao() {
      this.paginacao.visible = false;
      this.produtos.visible = false;
      this.produtos.promocao = true;
      this.paginacao.pagina = 1;
      this.ExibirProdutos('<', false, false);
      this.update.updating = false;
    },
    CarregarTelaDeLancamentos: function CarregarTelaDeLancamentos() {
      this.produtosLanc.showLanc = true;
      this.paginacao.visible = false;
      this.produtosLanc.visible = true;
      this.paginacao.pagina = 1;
      this.ExibirProdutos('<', true, false);
      this.update.updating = false;
    },
    CarregarTelaDeFornecedores: function CarregarTelaDeFornecedores() {
      var _this3 = this;

      this.global.sending = true;
      this.fornecedores.visible = true;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetSupliersLogos',
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this3.fornecedores.images = response.data.logos;
          _this3.global.sending = false;
        } else {
          _this3.ShowDialog('Não há imagens de fornecedores cadastradas.');
          _this3.global.sending = false;
        }
      }).catch(function (e) {
        _this3.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this3.global.sending = false;
      });
    },
    CarregarTelaDeHistoricoFinanceiro: function CarregarTelaDeHistoricoFinanceiro() {
      this.paginacao.visible = false;
      this.historicoFinanceiro.visible = true;
      this.paginacao.pagina = 1;
      this.ExibirHistoricoFinanceiro('<');
      this.update.updating = false;
    },
    ExibirHistoricoFinanceiro: function ExibirHistoricoFinanceiro(direcao) {
      this.paginacao.visible = false;

      if (direcao === '>') {
        this.paginacao.pagina++;
      } else if (direcao === '<') {
        if (this.paginacao.pagina > 1) {
          this.paginacao.pagina--;
        }
      }

      this.PesquisarHistoricoFinanceiro(false);
      this.paginacao.visible = true;
    },
    PesquisarHistoricoFinanceiro: function PesquisarHistoricoFinanceiro(paginaInicial) {
      var _this4 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.historicoFinanceiro.pesquisa.visible = false;
      this.update.updating = true;

      if (paginaInicial) {
        this.paginacao.pagina = 1;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/GetSpecificFinancialHistory',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          DataVencimentoInicial: this.historicoFinanceiro.pesquisa.dtVencIni,
          DataVencimentoFinal: this.historicoFinanceiro.pesquisa.dtVencFin,
          Pagina: this.paginacao.pagina
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this4.historicoFinanceiro.itens = response.data.historico;
          _this4.paginacao.totalPaginas = response.data.totalPaginas;
          _this4.update.updating = false;
        } else {
          _this4.update.updating = false;
          if (_this4.paginacao.pagina > 1) {
            _this4.paginacao.pagina--;
          }
          _this4.ShowDialog('Nenhum histórico financeiro foi encontrado.');
        }
      }).catch(function (e) {
        if (_this4.paginacao.pagina > 1) {
          _this4.paginacao.pagina--;
        }
        _this4.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this4.update.updating = false;
      });
    },
    CarregarTelaDePedidos: function CarregarTelaDePedidos() {
      this.pedidos.visible = true;
      this.ObterPedidos();
      this.GetAllOrderStatus();
    },
    ObterPedidos: function ObterPedidos() {
      var _this5 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.update.updating = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetSummaryOrders',
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this5.pedidos.itens = response.data;
          _this5.update.updating = false;
        } else {
          _this5.update.updating = false;
          _this5.ShowDialog('Nenhum pedido foi encontrado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.');
        }
      }).catch(function (e) {
        _this5.update.updating = false;
        _this5.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
      });
    },
    AbrirTelaDePesquisa: function AbrirTelaDePesquisa() {
      this.LimparFiltrosPesquisaProdutos();
      this.global.menuAcoesShow = false;
      this.produtos.pesquisa.visible = true;
      this.update.grayScreen = true;
    },
    AbrirTelaDePesquisaLancamento: function AbrirTelaDePesquisaLancamento() {
      this.LimparFiltrosPesquisaProdutosLancamento();
      this.produtosLanc.showLanc = false;
      this.global.menuAcoesShow = false;
      this.produtosLanc.pesquisa.visible = true;
      this.update.grayScreen = true;
    },
    AbrirTelaDePesquisaHistoricoFinanceiro: function AbrirTelaDePesquisaHistoricoFinanceiro() {
      this.global.menuAcoesShow = false;
      this.historicoFinanceiro.pesquisa.visible = true;
      this.update.grayScreen = true;
    },
    PesquisarProdutos: function PesquisarProdutos(paginaInicial) {
      var _this6 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.produtos.pesquisa.visible = false;
      this.update.updating = true;

      if (paginaInicial) {
        this.paginacao.pagina = 1;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/GetSpecificProducts',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          Code: this.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc,
          Release: this.produtos.pesquisa.lancSrc,
          Description: this.produtos.pesquisa.descSrc,
          Page: this.paginacao.pagina,
          PromocaoSomenteCatalogo: false
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this6.produtos.itens = response.data.produtos;
          _this6.paginacao.totalPaginas = response.data.totalPaginas;
          _this6.update.updating = false;
          _this6.paginacao.visible = true;
        } else {
          _this6.update.updating = false;
          if (_this6.paginacao.pagina > 1) {
            _this6.paginacao.pagina--;
          }
          _this6.ShowDialog('Nenhum produto foi encontrado.');
        }
      }).catch(function (e) {
        if (_this6.paginacao.pagina > 1) {
          _this6.paginacao.pagina--;
        }
        _this6.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this6.update.updating = false;
      });
    },
    PesquisarProdutosPromocao: function PesquisarProdutosPromocao(paginaInicial) {
      var _this7 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.produtos.pesquisa.visible = false;
      this.update.updating = true;

      if (paginaInicial) {
        this.paginacao.pagina = 1;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/GetSpecificProducts',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          Code: this.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc,
          Release: this.produtos.pesquisa.lancSrc,
          Description: this.produtos.pesquisa.descSrc,
          Page: this.paginacao.pagina,
          PromocaoSomenteCatalogo: true
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this7.produtos.itens = response.data.produtos;
          _this7.paginacao.totalPaginas = response.data.totalPaginas;
          _this7.update.updating = false;
          _this7.paginacao.visible = true;
        } else {
          _this7.update.updating = false;
          if (_this7.paginacao.pagina > 1) {
            _this7.paginacao.pagina--;
          }
          _this7.ShowDialog('Nenhum produto foi encontrado.');
        }
      }).catch(function (e) {
        if (_this7.paginacao.pagina > 1) {
          _this7.paginacao.pagina--;
        }
        _this7.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this7.update.updating = false;
      });
    },
    TimeOutPesquisarProdutosLancamento: function TimeOutPesquisarProdutosLancamento() {
      var _this8 = this;

      setTimeout(function () {
        _this8.PesquisarProdutosLancamento(true);
      }, 150);
    },
    TimeOutPesquisarProdutos: function TimeOutPesquisarProdutos() {
      var _this9 = this;

      setTimeout(function () {
        _this9.PesquisarProdutos(true);
      }, 150);
    },
    TimeOutPesquisarProdutosPromocao: function TimeOutPesquisarProdutosPromocao() {
      var _this10 = this;

      setTimeout(function () {
        _this10.PesquisarProdutos(true);
      }, 150);
    },
    PesquisarProdutosLancamento: function PesquisarProdutosLancamento(paginaInicial) {
      var _this11 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.produtosLanc.pesquisa.visible = false;
      this.update.updating = true;

      if (paginaInicial) {
        this.paginacao.pagina = 1;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/GetSpecificProducts',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          Code: this.produtosLanc.pesquisa.codigoEmpresaOriginalSimilarSrc,
          Release: this.produtosLanc.pesquisa.lancSrc,
          Description: this.produtosLanc.pesquisa.descSrc,
          Page: this.paginacao.pagina
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this11.produtosLanc.itens = response.data.produtos;
          _this11.paginacao.totalPaginas = response.data.totalPaginas;
          _this11.update.updating = false;
          _this11.paginacao.visible = true;
        } else {
          _this11.update.updating = false;
          if (_this11.paginacao.pagina > 1) {
            _this11.paginacao.pagina--;
          }
          _this11.ShowDialog('Nenhum produto foi encontrado.');
        }
      }).catch(function (e) {
        if (_this11.paginacao.pagina > 1) {
          _this11.paginacao.pagina--;
        }
        _this11.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this11.update.updating = false;
      });
    },
    ObterLancamentos: function ObterLancamentos() {
      var _this12 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.produtosLanc.pesquisa.visible = false;
      this.update.updating = true;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetSummaryNewProducts?id=' + this.paginacao.pagina,
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this12.produtosLanc.itens = response.data.produtos;
          _this12.paginacao.totalPaginas = response.data.totalPaginas;
          _this12.update.updating = false;
          _this12.paginacao.visible = true;
        } else {
          _this12.update.updating = false;
          _this12.ShowDialog('Nenhum produto foi encontrado.');
        }
      }).catch(function (e) {
        _this12.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this12.update.updating = false;
      });
    },
    LimparFiltrosPesquisaProdutos: function LimparFiltrosPesquisaProdutos() {
      this.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc = '';
      this.produtos.pesquisa.descSrc = '';
      this.produtos.pesquisa.lancSrc = null;
      this.global.enterControl = '';
    },
    LimparFiltrosPesquisaProdutosLancamento: function LimparFiltrosPesquisaProdutosLancamento() {
      this.produtosLanc.pesquisa.codigoEmpresaOriginalSimilarSrc = '';
      this.produtosLanc.pesquisa.descSrc = '';
      this.produtosLanc.pesquisa.lancSrc = null;
      this.global.enterControl = '';
    },
    GetProdInfo: function GetProdInfo(prodSel) {
      var _this13 = this;

      if (!this.IsLogged()) {
        return;
      }
      this.produtos.detalhe.visible = false;
      this.update.updating = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetProductInfo?id=' + prodSel.id,
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this13.ExibirDetalheProduto(response.data);
        } else {
          _this13.ShowDialog('Nenhum produto foi encontrado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.');
        }
        _this13.update.updating = false;
      }).catch(function (e) {
        _this13.update.updating = false;
        _this13.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
      });
    },
    ExibirProdutos: function ExibirProdutos(direcao, lancamento, paginaInicial) {
      this.paginacao.visible = false;

      if (direcao === '>') {
        if (this.paginacao.pagina !== this.paginacao.totalPaginas) {
          this.paginacao.pagina++;
        }
      } else if (direcao === '<') {
        if (this.paginacao.pagina > 1) {
          this.paginacao.pagina--;
        }
      }

      if (lancamento) {
        if (this.produtosLanc.showLanc) {
          this.ObterLancamentos();
        } else {
          this.PesquisarProdutosLancamento(paginaInicial);
        }
      } else {
        if (this.produtos.promocao) {
          this.PesquisarProdutosPromocao(paginaInicial);
        } else {
          this.PesquisarProdutos(paginaInicial);
        }
      }

      window.scrollTo(0, 0);
    },
    clearForm: function clearForm() {
      this.user.password = null;
      this.user.newPassword = null;
      this.user.confirmNewPassword = null;
    },
    saveUser: function saveUser() {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set('usr', this.user.cnpj);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set('cpn', this.user.company);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set('cdt', this.user.auth);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set('logo', this.user.logo);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set('name', this.user.name);
      this.userSaved = true;
      this.clearForm();
    },
    validateUser: function validateUser() {
      if (!this.user.cnpj !== undefined && !this.user.cnpj !== null && !this.user.cnpj !== '') {
        this.ObterEmpresas();
      }
    },
    validateLogin: function validateLogin() {
      if (this.user.company !== null && this.user.company !== undefined && this.user.company.length > 0) {
        this.EfetuarLogin();
      }
    },
    fecharPesquisaProduto: function fecharPesquisaProduto() {
      this.produtos.pesquisa.visible = false;
      this.update.grayScreen = false;
    },
    fecharPesquisaProdutoLancamento: function fecharPesquisaProdutoLancamento() {
      this.produtosLanc.pesquisa.visible = false;
      this.update.grayScreen = false;
    },
    FecharPesquisaHistoricoFinanceiro: function FecharPesquisaHistoricoFinanceiro() {
      this.historicoFinanceiro.pesquisa.visible = false;
      this.update.grayScreen = false;
    },
    ClearCredential: function ClearCredential() {
      this.clearForm();
    },
    ValidateCredential: function ValidateCredential() {
      var _this14 = this;

      this.update.updating = true;
      this.user.cnpj = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('usr');

      if (this.user.cnpj !== undefined && this.user.cnpj !== null && this.user.cnpj !== '') {
        this.user.company = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('cpn');
        this.user.auth = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('cdt');

        __WEBPACK_IMPORTED_MODULE_1_axios___default()({
          method: 'get',
          url: this.global.webApi + 'api/DSCOP/ValidateToken',
          headers: {
            Authorization: this.user.auth
          }
        }).then(function (response) {
          if (response.status === 200) {
            if (response.data === true) {
              _this14.logged = true;
              _this14.GerenciarNavegacao(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('activeRoute'));
            } else {
              _this14.EfetuarLogin();
            }
            _this14.update.updating = false;
          } else {
            _this14.ClearCredential();
            _this14.GerenciarNavegacao('login');
            _this14.ShowDialog('Sua sessão expirou, efetue o login novamente!');
            _this14.update.updating = false;
          }
        }).catch(function (e) {
          _this14.ClearCredential();
          _this14.GerenciarNavegacao('login');
          _this14.ShowDialog('Sua sessão expirou, efetue o login novamente!');
          _this14.update.updating = false;
        });
      } else {
        this.GerenciarNavegacao('login');
        this.update.updating = false;
      }
    },
    AddProd: function AddProd(item) {
      var _this15 = this;

      if (!this.IsLogged()) {
        return;
      }
      this.update.updating = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetProductInfo?id=' + item.id,
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this15.carrinho.inputQtd.item = response.data;
          _this15.update.updating = false;
          _this15.carrinho.inputQtd.visible = true;
        } else {
          _this15.update.updating = false;
          _this15.ShowDialog('Não foi possível carregar os dados do produtos selecionado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.');
        }
      }).catch(function (e) {
        _this15.update.updating = false;
        _this15.ShowDialog('Não foi possível carregar os dados do produtos selecionado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.');
      });
    },
    ConfirmAddProd: function ConfirmAddProd() {
      var _this16 = this;

      // Validar quantidade
      if (isNaN(this.carrinho.inputQtd.qtd)) {
        this.ShowDialog('Valor de quantidade informado é inválido!');
        return;
      }

      if (this.carrinho.inputQtd.qtd < 0 || this.carrinho.inputQtd.qtd > this.carrinho.inputQtd.item.stock) {
        this.ShowDialog('Valor informado não disponível para o produto!');
        return;
      }

      // Se não existir, adicionar ao carrinho
      if (this.carrinho.itens === undefined || this.carrinho.itens === null || this.carrinho.itens.length === 0) {
        this.carrinho.itens = [{
          id: this.carrinho.inputQtd.item.id,
          image: this.carrinho.inputQtd.item.image,
          code: this.carrinho.inputQtd.item.code,
          productGroup: this.carrinho.inputQtd.item.productGroup,
          description: this.carrinho.inputQtd.item.description,
          qtd: 0.000000,
          appQtd: parseFloat(this.carrinho.inputQtd.qtd.toFixed(6)),
          unity: this.carrinho.inputQtd.item.unity,
          price: 0.00,
          appPrice: this.carrinho.inputQtd.item.price,
          totalprice: 0.00,
          appTotalPrice: parseFloat((this.carrinho.inputQtd.qtd * this.carrinho.inputQtd.item.price.replace(',', '.')).toFixed(2))
        }];
      } else {
        // Verificar se já existe no carrinho
        // Se já existir exibir a mensagem para alterar na tela do carrinho
        var exist = this.carrinho.itens.filter(function (item) {
          return item.id === _this16.carrinho.inputQtd.item.id;
        });
        if (exist !== undefined && exist !== null && exist.length > 0) {
          this.ShowDialog('Item já adicionado no carrinho, para editar a quantidade vá até a página do carrinho!');
          return;
        }

        this.carrinho.itens.push({
          id: this.carrinho.inputQtd.item.id,
          image: this.carrinho.inputQtd.item.image,
          code: this.carrinho.inputQtd.item.code,
          productGroup: this.carrinho.inputQtd.item.productGroup,
          description: this.carrinho.inputQtd.item.description,
          qtd: 0.000000,
          appQtd: parseFloat(this.carrinho.inputQtd.qtd.toFixed(6)),
          unity: this.carrinho.inputQtd.item.unity,
          price: 0.00,
          appPrice: this.carrinho.inputQtd.item.price,
          totalPrice: 0.00,
          appTotalPrice: parseFloat((this.carrinho.inputQtd.qtd * this.carrinho.inputQtd.item.price.replace(',', '.')).toFixed(2))
        });
      }

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set(this.user.company + '_carrinho', this.carrinho.itens);

      this.carrinho.inputQtd.item = { stock: 0.00 };
      this.carrinho.inputQtd.qtd = 0.00;
      this.carrinho.inputQtd.visible = false;

      this.SumShoppingCart();
    },
    CancelAddProd: function CancelAddProd() {
      this.carrinho.inputQtd.item = { stock: 0.00 };
      this.carrinho.inputQtd.qtd = 0.00;
      this.carrinho.inputQtd.visible = false;

      this.SumShoppingCart();
    },
    EditProd: function EditProd(item) {
      var _this17 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.update.updating = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetProductInfo?id=' + item.id,
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this17.carrinho.editQtd.item = response.data;
          _this17.update.updating = false;
          _this17.carrinho.editQtd.visible = true;
        } else {
          _this17.update.updating = false;
          _this17.ShowDialog('Não foi possível carregar os dados do produtos selecionado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.');
        }
      }).catch(function (e) {
        _this17.update.updating = false;
        _this17.ShowDialog('Não foi possível carregar os dados do produtos selecionado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.');
      });
    },
    ConfirmEditProd: function ConfirmEditProd() {
      var _this18 = this;

      // Validar quantidade
      if (isNaN(this.carrinho.editQtd.qtd)) {
        this.ShowDialog('Valor de quantidade informado é inválido!');
        return;
      }

      if (this.carrinho.editQtd.qtd < 0 || this.carrinho.editQtd.qtd > this.carrinho.editQtd.item.stock) {
        this.ShowDialog('Valor informado não disponível para o produto!');
        return;
      }

      if (this.carrinho.editQtd.qtd === 0) {
        this.carrinho.itens = this.carrinho.itens.filter(function (x) {
          return x.id !== _this18.carrinho.editQtd.item.id;
        });
      } else {
        // Verificar se já existe no carrinho
        // Se já existir exibir a mensagem para alterar na tela do carrinho
        this.carrinho.itens.forEach(function (element) {
          if (element.id === _this18.carrinho.editQtd.item.id) {
            element.code = _this18.carrinho.editQtd.item.code;
            element.productGroup = _this18.carrinho.editQtd.item.productGroup;
            element.description = _this18.carrinho.editQtd.item.description;
            element.qtd = 0.000000;
            element.appQtd = parseFloat(_this18.carrinho.editQtd.qtd.toFixed(6));
            element.unity = _this18.carrinho.editQtd.item.unity;
            element.price = 0.00;
            element.appPrice = _this18.carrinho.editQtd.item.price;
            element.totalprice = 0.00;
            element.appTotalprice = parseFloat((_this18.carrinho.editQtd.qtd * parseFloat(_this18.carrinho.editQtd.item.price)).toFixed(2));
          }
        });
      }

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set(this.user.company + '_carrinho', this.carrinho.itens);

      this.carrinho.editQtd.item = { stock: 0.00 };
      this.carrinho.editQtd.qtd = 0.00;
      this.carrinho.editQtd.visible = false;

      this.SumShoppingCart();
    },
    CancelEditProd: function CancelEditProd() {
      this.carrinho.editQtd.item = { stock: 0.00 };
      this.carrinho.editQtd.qtd = 0.00;
      this.carrinho.editQtd.visible = false;

      this.SumShoppingCart();
    },
    DeleteProd: function DeleteProd(item) {
      this.carrinho.itens = this.carrinho.itens.filter(function (x) {
        return x.id !== item.id;
      });
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set(this.user.company + '_carrinho', this.carrinho.itens);
      this.SumShoppingCart();
    },
    AbrirDetalhesCarrinho: function AbrirDetalhesCarrinho() {
      this.global.menuAcoesShow = false;
      if (this.carrinho.itens !== undefined && this.carrinho.itens !== null && this.carrinho.itens.length > 0) {
        this.SumShoppingCart();
        this.carrinho.detalhe.visible = true;
      } else {
        this.ShowDialog('Não há itens no seu carrinho.');
      }
    },
    CloseInfoCarrinho: function CloseInfoCarrinho() {
      this.carrinho.detalhe.visible = false;
    },
    SumShoppingCart: function SumShoppingCart() {
      var _this19 = this;

      this.carrinho.detalhe.total = 0.00;
      this.carrinho.itens.forEach(function (element) {
        var _price = element.appPrice.replace(',', '.');
        var _qtd = element.appQtd;
        var _total = _price * _qtd;
        element.appTotalPrice = _total;
        _this19.carrinho.detalhe.total = _this19.carrinho.detalhe.total + element.appTotalPrice;
      });
      this.carrinho.detalhe.total = parseFloat(this.carrinho.detalhe.total.toFixed(2));
      this.carrinho.detalhe.total += '';
      this.carrinho.detalhe.total.replace('.', ',');
    },
    SendOrder: function SendOrder() {
      var _this20 = this;

      if (!this.IsLogged()) {
        return;
      }
      this.carrinho.detalhe.visible = false;
      this.update.updating = true;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/SendOrder',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          itens: this.carrinho.itens
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this20.ShowDialog('Pedido enviado com sucesso. Você será notificado assim que o pedido for avaliado.');
          _this20.LimparCarrinho();
          _this20.update.updating = false;
        } else {
          _this20.ShowDialog('Não foi possível enviar o pedido. Entre em contato com seu fornecedor.');
          _this20.update.updating = false;
          _this20.carrinho.detalhe.visible = true;
        }
      }).catch(function (e) {
        _this20.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this20.update.updating = false;
        _this20.carrinho.detalhe.visible = true;
      });
    },
    LimparCarrinho: function LimparCarrinho() {
      this.carrinho.itens = [];
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set(this.user.company + '_carrinho', []);
    },
    GetOrderInfo: function GetOrderInfo(item) {
      var _this21 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.update.updating = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetOrderInfo?id=' + item.solicitationNumber,
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this21.pedidos.detalhe.item = response.data;
          _this21.pedidos.detalhe.visible = true;
          _this21.update.updating = false;
        } else {
          _this21.ShowDialog('Nenhum pedido foi encontrado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.');
          _this21.update.updating = false;
        }
      }).catch(function (e) {
        _this21.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this21.update.updating = false;
      });
    },
    CloseOrderInfo: function CloseOrderInfo(item) {
      this.pedidos.detalhe.visible = false;
    },
    CancelOrder: function CancelOrder(item) {
      var _this22 = this;

      this.CloseOrderInfo();

      if (!this.IsLogged()) {
        return;
      }

      this.update.updating = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/CancelOrder?order=' + item.solicitationNumber,
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this22.ShowDialog(response.data);
          _this22.ObterPedidos();
          _this22.update.updating = false;
        } else {
          _this22.ShowDialog('Não foi possível cancelar o pedido. Entre em contato com seu fornecedor.');
          _this22.update.updating = false;
        }
      }).catch(function (e) {
        _this22.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this22.update.updating = false;
      });
    },
    OpenOrderSearch: function OpenOrderSearch() {
      this.global.menuAcoesShow = false;
      this.pedidos.pesquisa.visible = true;
    },
    GetAllOrderStatus: function GetAllOrderStatus() {
      var _this23 = this;

      if (!this.IsLogged()) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetAllOrderStatus',
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this23.pedidos.pesquisa.status = response.data;
        }
      }).catch(function (e) {
        _this23.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
      });
    },
    SearchOrders: function SearchOrders() {
      var _this24 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.pedidos.pesquisa.visible = false;
      this.update.updating = true;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/SearchOrders',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          InitialDate: this.pedidos.pesquisa.initialDateSrc,
          FinalDate: this.pedidos.pesquisa.finalDateSrc,
          Status: this.pedidos.pesquisa.statusSrc
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this24.pedidos.itens = response.data;
          _this24.update.updating = false;
        } else {
          _this24.ShowDialog('Nenhum pedido foi encontrado.');
          _this24.update.updating = false;
        }
      }).catch(function (e) {
        _this24.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this24.update.updating = false;
      });
    },
    BuscarHistorioFinanceiro: function BuscarHistorioFinanceiro() {
      var _this25 = this;

      if (!this.IsLogged()) {
        return;
      }

      this.pedidos.pesquisa.visible = false;
      this.update.updating = true;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/SearchOrders',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          InitialDate: this.pedidos.pesquisa.initialDateSrc,
          FinalDate: this.pedidos.pesquisa.finalDateSrc,
          Status: this.pedidos.pesquisa.statusSrc
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this25.pedidos.itens = response.data;
          _this25.update.updating = false;
        } else {
          _this25.ShowDialog('Nenhum pedido foi encontrado.');
          _this25.update.updating = false;
        }
      }).catch(function (e) {
        _this25.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.');
        _this25.update.updating = false;
      });
    },
    CloseOrderSearch: function CloseOrderSearch() {
      this.pedidos.pesquisa.visible = false;
    },
    GetImage: function GetImage(id) {
      if (!this.IsLogged()) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetMainImage?id=' + id,
        headers: {
          Authorization: this.user.auth
        }
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data !== 0) {
            document.getElementById(id).src = response.data;
          } else {
            document.getElementById(id).src = './static/img/0.0ef68e7.jpg';
          }
        }
      }).catch(function (e) {
        document.getElementById(id).src = './static/img/0.0ef68e7.jpg';
      });
    },
    IsLogged: function IsLogged() {
      return this.logged;
    },
    ObterUltimaData: function ObterUltimaData() {
      var data = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get(this.user.company + '_ultDt');

      if (data !== undefined && data !== null) {
        return data;
      } else {
        return '01/01/1900';
      }
    },
    AtualizarUltimaData: function AtualizarUltimaData() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; // January is 0!
      var yyyy = today.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = dd + '/' + mm + '/' + yyyy;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.set(this.user.company + '_ultDt', today);
    },
    ArrayUniqueItem: function ArrayUniqueItem(array) {
      var a = array.concat();
      for (var i = 0; i < a.length; ++i) {
        for (var j = i + 1; j < a.length; ++j) {
          if (a[i].id === a[j].id) {
            a.splice(j--, 1);
          }
        }
      }
      return a;
    },
    AddQtd1: function AddQtd1() {
      this.carrinho.inputQtd.qtd = this.carrinho.inputQtd.qtd + this.carrinho.inputQtd.item.unitiesOnPackage;
    },
    RmvQtd1: function RmvQtd1() {
      this.carrinho.inputQtd.qtd = this.carrinho.inputQtd.qtd - this.carrinho.inputQtd.item.unitiesOnPackage;
    },
    AddQtd2: function AddQtd2() {
      this.carrinho.editQtd.qtd = this.carrinho.editQtd.qtd + this.carrinho.editQtd.item.unitiesOnPackage;
    },
    RmvQtd2: function RmvQtd2() {
      this.carrinho.editQtd.qtd = this.carrinho.editQtd.qtd - this.carrinho.editQtd.item.unitiesOnPackage;
    },
    Fixed: function Fixed(value, precision) {
      return Number(value).toFixed(precision);
    },
    AbrirTelaRecuperacaoSenha: function AbrirTelaRecuperacaoSenha() {
      this.global.recuperaSenhaVisible = true;
    },
    RecuperarSenha: function RecuperarSenha() {
      var _this26 = this;

      this.global.recuperaSenhaVisible = false;
      this.global.sending = true;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/RecoverPassword',
        data: {
          User: this.user.cnpj,
          Email: this.user.email,
          Company: this.user.company,
          Schema: this.global.schema
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this26.ShowDialog('Uma nova senha foi criada e enviada no seu email!');
        } else {
          _this26.ShowDialog('Não foi possível recuperar sua senha. Verifique o email de recuperação cadastrado com a loja!');
        }
        _this26.global.sending = false;
      }).catch(function (e) {
        _this26.ShowDialog('Não foi possível recuperar sua senha. Verifique o email de recuperação cadastrado com a loja!');
        _this26.global.sending = false;
      });
    },
    AbrirTelaAlteracaoSenha: function AbrirTelaAlteracaoSenha() {
      this.global.menuVisible = false;
      this.global.alteraSenhaVisible = true;
    },
    AlterarSenha: function AlterarSenha() {
      var _this27 = this;

      this.update.updating = true;

      if (this.user.newPassword === this.user.confirmNewPassword) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default()({
          method: 'post',
          url: this.global.webApi + 'api/DSCOP/ChangePassword',
          headers: {
            Authorization: this.user.auth
          },
          data: {
            OldPassword: this.user.password,
            NewPassword: this.user.newPassword,
            ConfirmNewPassword: this.user.confirmNewPassword
          }
        }).then(function (response) {
          if (response.status === 200) {
            _this27.clearForm();
            _this27.ShowDialog('Senha alterada com sucesso!');
          } else {
            _this27.ShowDialog('Não foi possível alterar sua senha. Entre em contato com a loja!');
          }
          _this27.update.updating = false;
        }).catch(function (e) {
          _this27.ShowDialog('Não foi possível alterar sua senha. Entre em contato com a loja!');
          _this27.update.updating = false;
        });
        this.global.alteraSenhaVisible = false;
      } else {
        this.ShowDialog('Nova senha diferente da senha de confirmação!');
      }
    }
  }
});

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container md-layout-column",staticStyle:{"text-align":"center"}},[_c('md-toolbar',{staticClass:"md-primary",staticStyle:{"position":"fixed","top":"0px"}},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.login.visible),expression:"$root.login.visible"}],staticClass:"md-icon-button"},[_c('img',{attrs:{"src":"static/img/icons/favicon-32x32.png","alt":"Logo"}})]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$root.login.visible),expression:"!$root.login.visible"}],staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.global.menuVisible = !_vm.$root.global.menuVisible}}},[_c('md-icon',[_vm._v("menu")])],1),_vm._v(" "),_c('span',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$root.global.activeRoute))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$root.login.visible),expression:"!$root.login.visible"}],staticClass:"md-toolbar-section-end"},[_c('md-avatar',{staticStyle:{"margin-right":"0"}},[_c('img',{attrs:{"src":"static/img/icons/favicon-32x32.png","alt":"Avatar"}}),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v(_vm._s(_vm.$root.user.name))])],1)],1)],1),_vm._v(" "),_c('md-drawer',{staticStyle:{"position":"fixed"},attrs:{"md-active":_vm.$root.global.menuVisible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.global, "menuVisible", $event)}}},[_c('md-toolbar',{staticClass:"md-transparent",attrs:{"md-elevation":"0"}},[_c('img',{staticStyle:{"margin-bottom":"10px"},attrs:{"src":_vm.$root.user.logo,"alt":"Logo"}})]),_vm._v(" "),_c('md-list',[_c('md-list-item',{on:{"click":function($event){_vm.$root.GerenciarNavegacao('home')}}},[_vm._v("Início\n        "),_c('md-icon',[_vm._v("home")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":function($event){_vm.$root.GerenciarNavegacao('produtos_lancamentos')}}},[_vm._v("Lançamentos\n        "),_c('md-icon',[_vm._v("new_releases")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":function($event){_vm.$root.GerenciarNavegacao('produtos_promocao')}}},[_vm._v("Promoções\n        "),_c('md-icon',[_vm._v("money_off")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":function($event){_vm.$root.GerenciarNavegacao('produtos')}}},[_vm._v("Pesquisar Produtos\n        "),_c('md-icon',[_vm._v("find_in_page")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":function($event){_vm.$root.GerenciarNavegacao('carrinho')}}},[_vm._v("Concluir Pedido\n        "),_c('md-icon',[_vm._v("shopping_cart")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":function($event){_vm.$root.GerenciarNavegacao('pedidos')}}},[_vm._v("Pedidos Realizados\n        "),_c('md-icon',[_vm._v("list")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":function($event){_vm.$root.GerenciarNavegacao('historico_financeiro')}}},[_vm._v("Relatório Financeiro\n        "),_c('md-icon',[_vm._v("attach_money")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":function($event){_vm.$root.AbrirTelaAlteracaoSenha()}}},[_vm._v("Alterar Senha\n        "),_c('md-icon',[_vm._v("settings")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":function($event){_vm.$root.Logoff()}}},[_vm._v("Sair\n        "),_c('md-icon',[_vm._v("power_settings_new")])],1)],1)],1),_vm._v(" "),_c('md-content',{staticStyle:{"padding-top":"70px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.login.visible),expression:"$root.login.visible"}]},[_c('md-card',{staticClass:"md-layout-item md-size-25 md-small-size-100"},[_c('md-card-content',[_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item md-small-size-100"},[_c('md-field',{attrs:{"id":"fieldCNPJ"}},[_c('label',{attrs:{"for":"cnpj"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('md-input',{attrs:{"name":"cnpj","id":"cnpj","autocomplete":"given-cnpj","disabled":_vm.$root.global.sending},model:{value:(_vm.$root.user.cnpj),callback:function ($$v) {_vm.$set(_vm.$root.user, "cnpj", $$v)},expression:"$root.user.cnpj"}})],1),_vm._v(" "),_c('md-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.login.validId),expression:"$root.login.validId"}],attrs:{"id":"fieldEmpresas"}},[_c('label',{attrs:{"for":"company"}},[_vm._v("Empresas")]),_vm._v(" "),_c('md-select',{attrs:{"name":"company","md-dense":"","disabled":_vm.$root.global.sending},model:{value:(_vm.$root.user.company),callback:function ($$v) {_vm.$set(_vm.$root.user, "company", $$v)},expression:"$root.user.company"}},_vm._l((_vm.$root.login.companies),function(comp){return _c('md-option',{attrs:{"value":comp.companyCnpj}},[_vm._v(_vm._s(comp.companyName1))])}))],1),_vm._v(" "),_c('md-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.login.validId),expression:"$root.login.validId"}],attrs:{"id":"fieldSenha"}},[_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('md-input',{attrs:{"name":"password","type":"password","id":"password","autocomplete":"given-senha"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.validateLogin()}},model:{value:(_vm.$root.user.password),callback:function ($$v) {_vm.$set(_vm.$root.user, "password", $$v)},expression:"$root.user.password"}})],1)],1)]),_vm._v(" "),_c('a',{staticClass:"md-top-left",attrs:{"href":"#"},on:{"click":function($event){_vm.$root.AbrirTelaRecuperacaoSenha()}}},[_vm._v("Recuperar Senha")])]),_vm._v(" "),_c('md-progress-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.global.sending),expression:"$root.global.sending"}],attrs:{"md-mode":"indeterminate"}}),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-raised md-primary",attrs:{"disabled":_vm.$root.global.sending},on:{"click":function($event){_vm.$root.validateUser()}}},[_vm._v("BUSCAR")]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.login.validId),expression:"$root.login.validId"}],staticClass:"md-raised md-primary",attrs:{"disabled":_vm.$root.global.sending},on:{"click":function($event){_vm.$root.validateLogin()}}},[_vm._v("ENTRAR")])],1)],1),_vm._v(" "),_c('md-snackbar',{attrs:{"md-active":_vm.$root.$root.user.saved},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.$root.user, "saved", $event)}}},[_vm._v("The user "+_vm._s(_vm.$root.login.lastUser)+" was saved with success!")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.home.visible),expression:"$root.home.visible"}]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.produtosLanc.visible),expression:"$root.produtosLanc.visible"}]},[_vm._l((_vm.$root.produtosLanc.itens),function(item){return _c('div',{staticStyle:{"text-align":"left"},attrs:{"id":"prodCard"}},[_c('md-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.paginacao.visible),expression:"$root.paginacao.visible"}],staticClass:"md-elevation-9",attrs:{"md-elevation":"9"}},[_c('md-card-area',[_c('md-card-media',[_c('img',{attrs:{"src":item.image,"alt":"Produto"},on:{"click":function($event){_vm.$root.GetProdInfo(item)}}})]),_vm._v(" "),_c('md-card-header',[_c('div',{on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('md-card-header-text',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(item.productGroup)+" / "+_vm._s(item.productSubgroup))])])],1)]),_vm._v(" "),_c('md-card-content',[_c('div',{on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('p',[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(item.description))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Estoque:")]),_vm._v(" "+_vm._s(item.stockStatus)+" / "),_c('strong',[_vm._v("Preço:")]),_vm._v(" R$ "+_vm._s(item.preco)+" ")])]),_vm._v(" "),_c('md-card-actions',[_c('div',{staticClass:"MarcaPecaProdutoHolder"},[_c('img',{staticClass:"MarcaPecaProduto",attrs:{"src":item.marcaPecaProduto,"alt":"MarcaPecaProduto"}})]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('md-icon',[_vm._v("info")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.AddProd(item)}}},[_c('md-icon',[_vm._v("add_shopping_cart")])],1)],1)],1)],1)],1)],1)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.paginacao.visible),expression:"$root.paginacao.visible"}],staticClass:"md-layout md-alignment-top-center chevron-holder"},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:((_vm.$root.paginacao.pagina !== 1)),expression:"($root.paginacao.pagina !== 1)"}],staticClass:"md-raised chevron-size",on:{"click":function($event){_vm.$root.ExibirProdutos('<', true, false)}}},[_c('md-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('div',{attrs:{"id":"pagCount"}},[_c('strong',[_vm._v(_vm._s(_vm.$root.paginacao.pagina)+" / "+_vm._s(_vm.$root.paginacao.totalPaginas))])]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:((_vm.$root.paginacao.pagina !== _vm.$root.paginacao.totalPaginas)),expression:"($root.paginacao.pagina !== $root.paginacao.totalPaginas)"}],staticClass:"md-raised chevron-size",on:{"click":function($event){_vm.$root.ExibirProdutos('>', true, false)}}},[_c('md-icon',[_vm._v("chevron_right")])],1)],1)],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.produtos.visible || _vm.$root.produtos.promocao),expression:"$root.produtos.visible || $root.produtos.promocao"}]},[_vm._l((_vm.$root.produtos.itens),function(item){return _c('div',{staticStyle:{"text-align":"left"},attrs:{"id":"prodCard"}},[_c('md-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.paginacao.visible),expression:"$root.paginacao.visible"}],staticClass:"md-elevation-9",attrs:{"md-elevation":"9"}},[_c('md-card-area',[_c('md-card-media',[_c('img',{attrs:{"src":item.image,"alt":"Produto"},on:{"click":function($event){_vm.$root.GetProdInfo(item)}}})]),_vm._v(" "),_c('md-card-header',[_c('div',{on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('md-card-header-text',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(item.productGroup)+" / "+_vm._s(item.productSubgroup))])])],1)]),_vm._v(" "),_c('md-card-content',[_c('div',{on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('p',[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(item.description))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Estoque:")]),_vm._v(" "+_vm._s(item.stockStatus)+" / "),_c('strong',[_vm._v("Preço:")]),_vm._v(" R$ "+_vm._s(item.preco)+" ")])]),_vm._v(" "),_c('md-card-actions',[_c('div',{staticClass:"MarcaPecaProdutoHolder"},[_c('img',{staticClass:"MarcaPecaProduto",attrs:{"src":item.marcaPecaProduto,"alt":"MarcaPecaProduto"}})]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('md-icon',[_vm._v("info")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.AddProd(item)}}},[_c('md-icon',[_vm._v("add_shopping_cart")])],1)],1)],1)],1)],1)],1)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.paginacao.visible),expression:"$root.paginacao.visible"}],staticClass:"md-layout md-alignment-top-center chevron-holder"},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:((_vm.$root.paginacao.pagina !== 1)),expression:"($root.paginacao.pagina !== 1)"}],staticClass:"md-raised chevron-size",on:{"click":function($event){_vm.$root.ExibirProdutos('<', false, false)}}},[_c('md-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('div',{attrs:{"id":"pagCount"}},[_c('strong',[_vm._v(_vm._s(_vm.$root.paginacao.pagina)+" / "+_vm._s(_vm.$root.paginacao.totalPaginas))])]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:((_vm.$root.paginacao.pagina !== _vm.$root.paginacao.totalPaginas)),expression:"($root.paginacao.pagina !== $root.paginacao.totalPaginas)"}],staticClass:"md-raised chevron-size",on:{"click":function($event){_vm.$root.ExibirProdutos('>', false, false)}}},[_c('md-icon',[_vm._v("chevron_right")])],1)],1)],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.carrinho.visible),expression:"$root.carrinho.visible"}]},_vm._l((_vm.$root.carrinho.itens),function(item){return _c('div',{staticStyle:{"text-align":"left"},attrs:{"id":"prodCard"}},[_c('md-card',{staticClass:"md-elevation-9",attrs:{"md-elevation":"9"}},[_c('md-card-area',[_c('md-card-media',[_c('img',{attrs:{"src":item.image,"alt":"Produto"},on:{"click":function($event){_vm.$root.GetProdInfo(item)}}})]),_vm._v(" "),_c('md-card-header',[_c('div',{on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('md-card-header-text',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(item.productGroup)+" / "+_vm._s(item.productSubgroup))])])],1)]),_vm._v(" "),_c('md-card-content',[_c('div',{on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('p',[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(item.description))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Quantidade:")]),_vm._v(" "+_vm._s(item.appQtd)+" "+_vm._s(item.unity)+" / "),_c('strong',[_vm._v("Preço:")]),_vm._v(" R$ "+_vm._s((item.appPrice)))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Valor Total:")]),_vm._v(" R$ "+_vm._s((item.appTotalPrice)))])]),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('md-icon',[_vm._v("info")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.EditProd(item)}}},[_c('md-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.DeleteProd(item)}}},[_c('md-icon',[_vm._v("remove_shopping_cart")])],1)],1)],1)],1)],1)],1)})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.historicoFinanceiro.visible),expression:"$root.historicoFinanceiro.visible"}]},[_c('md-table',{attrs:{"id":"pedidoCard","md-sort":"dataVencimento","md-sort-order":"desc","md-card":"","md-fixed-header":""},scopedSlots:_vm._u([{key:"md-table-row",fn:function(ref){
var item = ref.item;
return _c('md-table-row',{},[_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Documento","md-sort-by":"documento"}},[_vm._v(_vm._s(item.documento))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Data","md-sort-by":"dtConta"}},[_vm._v(_vm._s(item.dtConta))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Vencimento","md-sort-by":"dtVencto"}},[_vm._v(_vm._s(item.dtVencto))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Pagamento","md-sort-by":"dtPagto"}},[_vm._v(_vm._s(item.dtPagto))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Valor","md-sort-by":"valor"}},[_vm._v(_vm._s(item.vl))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Valor Pago","md-sort-by":"vlPago"}},[_vm._v(_vm._s(item.vlPago))])],1)}}]),model:{value:(_vm.$root.historicoFinanceiro.itens),callback:function ($$v) {_vm.$set(_vm.$root.historicoFinanceiro, "itens", $$v)},expression:"$root.historicoFinanceiro.itens"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.paginacao.visible),expression:"$root.paginacao.visible"}],staticClass:"md-layout md-alignment-top-center"},[_c('md-button',{staticClass:"md-raised",on:{"click":function($event){_vm.$root.ExibirHistoricoFinanceiro('<')}}},[_c('md-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('div',{attrs:{"id":"pagCount"}},[_c('strong',[_vm._v(_vm._s(_vm.$root.paginacao.pagina)+" / "+_vm._s(_vm.$root.paginacao.totalPaginas))])]),_vm._v(" "),_c('md-button',{staticClass:"md-raised",on:{"click":function($event){_vm.$root.ExibirHistoricoFinanceiro('>')}}},[_c('md-icon',[_vm._v("chevron_right")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.historicoFinanceiro.pesquisa.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.historicoFinanceiro.pesquisa, "visible", $event)}}},[_c('md-dialog-title',[_vm._v("Pesquisar Histórico")]),_vm._v(" "),_c('md-dialog-content',[_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Vencimento Inicial")]),_vm._v(" "),_c('md-input',{attrs:{"id":"teste1"},on:{"keyup":function($event){_vm.$root.MaskDateVenctoIni()}},model:{value:(_vm.$root.historicoFinanceiro.pesquisa.dtVencIni),callback:function ($$v) {_vm.$set(_vm.$root.historicoFinanceiro.pesquisa, "dtVencIni", $$v)},expression:"$root.historicoFinanceiro.pesquisa.dtVencIni"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Vencimento Final")]),_vm._v(" "),_c('md-input',{attrs:{"id":"teste2"},on:{"keyup":function($event){_vm.$root.MaskDateVenctoFin()}},model:{value:(_vm.$root.historicoFinanceiro.pesquisa.dtVencFin),callback:function ($$v) {_vm.$set(_vm.$root.historicoFinanceiro.pesquisa, "dtVencFin", $$v)},expression:"$root.historicoFinanceiro.pesquisa.dtVencFin"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.PesquisarHistoricoFinanceiro(true)}}},[_vm._v("Buscar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.FecharPesquisaHistoricoFinanceiro()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.pedidos.visible),expression:"$root.pedidos.visible"}]},[_c('md-table',{attrs:{"id":"pedidoCard","md-sort":"name","md-sort-order":"asc","md-card":"","md-fixed-header":""},scopedSlots:_vm._u([{key:"md-table-row",fn:function(ref){
var item = ref.item;
return _c('md-table-row',{on:{"dblclick":function($event){_vm.$root.GetOrderInfo(item)}}},[_c('md-table-cell',{staticStyle:{"text-align":"right"},attrs:{"md-label":"Solicitação Nº","md-sort-by":"solicitationNumber","md-numeric":""}},[_vm._v(_vm._s(item.solicitationNumber))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"right"},attrs:{"md-label":"Pedido Nº","md-sort-by":"orderNumber","md-numeric":""}},[_vm._v(_vm._s(item.orderNumber))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Status","md-sort-by":"status"}},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Data","md-sort-by":"orderDate"}},[_vm._v(_vm._s(item.orderDate))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"text-align":"left"},attrs:{"md-label":"Valor","md-sort-by":"totalPrice"}},[_vm._v("R$ "+_vm._s(item.totalPrice))])],1)}}]),model:{value:(_vm.$root.pedidos.itens),callback:function ($$v) {_vm.$set(_vm.$root.pedidos, "itens", $$v)},expression:"$root.pedidos.itens"}},[_c('md-table-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Pedidos")])])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.fornecedores.visible),expression:"$root.fornecedores.visible"}]},[_c('md-content',{staticStyle:{"padding":"10px"}},_vm._l((_vm.$root.fornecedores.images),function(item){return _c('img',{staticStyle:{"margin":"10px"},attrs:{"src":item,"alt":"Fornecedores"}})}))],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.configuracoes.visible),expression:"$root.configuracoes.visible"}]}),_vm._v(" "),_c('md-speed-dial',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.produtosLanc.visible),expression:"$root.produtosLanc.visible"}],staticClass:"md-bottom-right",staticStyle:{"position":"fixed","z-index":"4"},attrs:{"md-direction":"top"}},[_c('md-speed-dial-target',{on:{"click":function($event){_vm.$root.AbrirTelaDePesquisaLancamento()}}},[_c('md-icon',{staticStyle:{"width":"100%","display":"block"}},[_vm._v("search")]),_vm._v(" "),_c('label',{staticStyle:{"color":"#fff","font-size":".6rem"},attrs:{"for":"first-name"}},[_vm._v("Buscar")])],1)],1),_vm._v(" "),_c('md-speed-dial',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.produtos.visible),expression:"$root.produtos.visible"}],staticClass:"md-bottom-right",staticStyle:{"position":"fixed","z-index":"4"},attrs:{"md-direction":"top"}},[_c('md-speed-dial-target',{on:{"click":function($event){_vm.$root.AbrirTelaDePesquisa()}}},[_c('md-icon',{staticStyle:{"width":"100%","display":"block"}},[_vm._v("search")]),_vm._v(" "),_c('label',{staticStyle:{"color":"#fff","font-size":".6rem"},attrs:{"for":"first-name"}},[_vm._v("Buscar")])],1)],1),_vm._v(" "),_c('md-speed-dial',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.historicoFinanceiro.visible),expression:"$root.historicoFinanceiro.visible"}],staticClass:"md-bottom-right",staticStyle:{"position":"fixed","z-index":"4"},attrs:{"md-direction":"top"}},[_c('md-speed-dial-target',{on:{"click":function($event){_vm.$root.AbrirTelaDePesquisaHistoricoFinanceiro()}}},[_c('md-icon',{staticStyle:{"width":"100%","display":"block"}},[_vm._v("search")]),_vm._v(" "),_c('label',{staticStyle:{"color":"#fff","font-size":".6rem"},attrs:{"for":"first-name"}},[_vm._v("Buscar")])],1)],1),_vm._v(" "),_c('md-speed-dial',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.carrinho.visible),expression:"$root.carrinho.visible"}],staticClass:"md-bottom-right",staticStyle:{"position":"fixed","z-index":"4"},attrs:{"md-direction":"top"}},[_c('md-speed-dial-target',{on:{"click":function($event){_vm.$root.AbrirDetalhesCarrinho()}}},[_c('md-icon',{staticStyle:{"width":"100%","display":"block"}},[_vm._v("assignment")]),_vm._v(" "),_c('label',{staticStyle:{"color":"#fff","font-size":".6rem"},attrs:{"for":"first-name"}},[_vm._v("Resumo")])],1)],1),_vm._v(" "),_c('md-speed-dial',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.pedidos.visible),expression:"$root.pedidos.visible"}],staticClass:"md-bottom-right",staticStyle:{"position":"fixed","z-index":"4"},attrs:{"md-direction":"top"}},[_c('md-speed-dial-target',{on:{"click":function($event){_vm.$root.OpenOrderSearch()}}},[_c('md-icon',{staticStyle:{"width":"100%","display":"block"}},[_vm._v("search")]),_vm._v(" "),_c('label',{staticStyle:{"color":"#fff","font-size":".6rem"},attrs:{"for":"first-name"}},[_vm._v("Buscar")])],1)],1)],1),_vm._v(" "),_c('link',{attrs:{"rel":"stylesheet","href":"//fonts.googleapis.com/css?family=Roboto:400,500,700,400italic|Material+Icons"}}),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.produtosLanc.pesquisa.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.produtosLanc.pesquisa, "visible", $event)}}},[_c('md-dialog-title',[_vm._v("Pesquisar Produtos")]),_vm._v(" "),_c('md-dialog-content',[_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Código Empresa/Original/Similar")]),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.TimeOutPesquisarProdutosLancamento()}},model:{value:(_vm.$root.produtosLanc.pesquisa.codigoEmpresaOriginalSimilarSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtosLanc.pesquisa, "codigoEmpresaOriginalSimilarSrc", $$v)},expression:"$root.produtosLanc.pesquisa.codigoEmpresaOriginalSimilarSrc"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Descrição")]),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.TimeOutPesquisarProdutosLancamento()}},model:{value:(_vm.$root.produtosLanc.pesquisa.descSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtosLanc.pesquisa, "descSrc", $$v)},expression:"$root.produtosLanc.pesquisa.descSrc"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Lançamentos")]),_vm._v(" "),_c('md-select',{model:{value:(_vm.$root.produtosLanc.pesquisa.lancSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtosLanc.pesquisa, "lancSrc", $$v)},expression:"$root.produtosLanc.pesquisa.lancSrc"}},[_c('md-option',{attrs:{"value":30}},[_vm._v("30 Dias")]),_vm._v(" "),_c('md-option',{attrs:{"value":60}},[_vm._v("60 Dias")]),_vm._v(" "),_c('md-option',{attrs:{"value":90}},[_vm._v("90 Dias")])],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.TimeOutPesquisarProdutosLancamento()}}},[_vm._v("Buscar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.LimparFiltrosPesquisaProdutosLancamento()}}},[_vm._v("Limpar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.fecharPesquisaProdutoLancamento()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.produtos.pesquisa.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.produtos.pesquisa, "visible", $event)}}},[_c('md-dialog-title',[_vm._v("Pesquisar Produtos")]),_vm._v(" "),_c('md-dialog-content',[_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Código Empresa/Original/Similar")]),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.TimeOutPesquisarProdutos()}},model:{value:(_vm.$root.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtos.pesquisa, "codigoEmpresaOriginalSimilarSrc", $$v)},expression:"$root.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Descrição")]),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.TimeOutPesquisarProdutos()}},model:{value:(_vm.$root.produtos.pesquisa.descSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtos.pesquisa, "descSrc", $$v)},expression:"$root.produtos.pesquisa.descSrc"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Lançamentos")]),_vm._v(" "),_c('md-select',{model:{value:(_vm.$root.produtos.pesquisa.lancSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtos.pesquisa, "lancSrc", $$v)},expression:"$root.produtos.pesquisa.lancSrc"}},[_c('md-option',{attrs:{"value":30}},[_vm._v("30 Dias")]),_vm._v(" "),_c('md-option',{attrs:{"value":60}},[_vm._v("60 Dias")]),_vm._v(" "),_c('md-option',{attrs:{"value":90}},[_vm._v("90 Dias")])],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.TimeOutPesquisarProdutos()}}},[_vm._v("Buscar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.LimparFiltrosPesquisaProdutos()}}},[_vm._v("Limpar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.fecharPesquisaProduto()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.produtos.pesquisa.promocao},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.produtos.pesquisa, "promocao", $event)}}},[_c('md-dialog-title',[_vm._v("Pesquisar Promoções")]),_vm._v(" "),_c('md-dialog-content',[_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Código Empresa/Original/Similar")]),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.TimeOutPesquisarProdutosPromocao()}},model:{value:(_vm.$root.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtos.pesquisa, "codigoEmpresaOriginalSimilarSrc", $$v)},expression:"$root.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Descrição")]),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.TimeOutPesquisarProdutosPromocao()}},model:{value:(_vm.$root.produtos.pesquisa.descSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtos.pesquisa, "descSrc", $$v)},expression:"$root.produtos.pesquisa.descSrc"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Lançamentos")]),_vm._v(" "),_c('md-select',{model:{value:(_vm.$root.produtos.pesquisa.lancSrc),callback:function ($$v) {_vm.$set(_vm.$root.produtos.pesquisa, "lancSrc", $$v)},expression:"$root.produtos.pesquisa.lancSrc"}},[_c('md-option',{attrs:{"value":30}},[_vm._v("30 Dias")]),_vm._v(" "),_c('md-option',{attrs:{"value":60}},[_vm._v("60 Dias")]),_vm._v(" "),_c('md-option',{attrs:{"value":90}},[_vm._v("90 Dias")])],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.TimeOutPesquisarProdutosPromocao()}}},[_vm._v("Buscar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.LimparFiltrosPesquisaProdutos()}}},[_vm._v("Limpar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.fecharPesquisaProduto()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{staticStyle:{"width":"100%"},attrs:{"md-active":_vm.$root.produtos.detalhe.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.produtos.detalhe, "visible", $event)}}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$root.produtos.detalhe.menuTitle))]),_vm._v(" "),_c('md-tabs',{staticStyle:{"max-width":"100% !important"},attrs:{"md-dynamic-height":""}},[_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-icon":"menu"},on:{"click":function($event){_vm.$root.produtos.detalhe.menuTitle = 'Geral';}}},[_c('div',{staticClass:"MarcaPecaProdutoHolderTopLeft"},[_c('p',[_c('strong',[_vm._v("Código:")]),_vm._v(" "+_vm._s(_vm.$root.produtos.detalhe.code))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Grupo:")]),_vm._v(" "+_vm._s(_vm.$root.produtos.detalhe.productGroup)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Subgrupo:")]),_vm._v(" "+_vm._s(_vm.$root.produtos.detalhe.productSubgroup))])]),_vm._v(" "),_c('div',{staticClass:"MarcaPecaProdutoHolderTopRight"},[_c('img',{staticClass:"MarcaPecaProduto",attrs:{"src":_vm.$root.produtos.detalhe.marcaPecaProduto}})]),_vm._v(" "),_c('div',{staticClass:"MarcaPecaProdutoHolderFull"},[_c('p',[_c('strong',[_vm._v("Descrição:")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$root.produtos.detalhe.description)}})]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Descrição Completa:")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$root.produtos.detalhe.completeDescription)}})]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Estoque:")]),_vm._v(" "+_vm._s(_vm.$root.produtos.detalhe.stock)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Unidade:")]),_vm._v(" "+_vm._s(_vm.$root.produtos.detalhe.unity)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Preço:")]),_vm._v(" R$ "+_vm._s(_vm.$root.produtos.detalhe.price))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Códigos Originais:")])]),_vm._v(" "),_vm._l((_vm.$root.produtos.detalhe.originalCodes),function(item){return _c('div',[_vm._v("\n                     - "+_vm._s(item.originalCode)),_c('br')])}),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Observações:")]),_vm._v(" "+_vm._s(_vm.$root.produtos.detalhe.observations))])],2)]),_vm._v(" "),_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-icon":"widgets"},on:{"click":function($event){_vm.$root.produtos.detalhe.menuTitle = 'Similares';}}},[_c('div',{staticStyle:{"display":"inline-block"}},_vm._l((_vm.$root.produtos.detalhe.similar),function(item){return _c('div',{staticStyle:{"text-align":"left"},attrs:{"id":"prodCard"}},[_c('md-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.paginacao.visible),expression:"$root.paginacao.visible"}],staticClass:"md-elevation-9",attrs:{"md-elevation":"9"}},[_c('md-card-area',[_c('md-card-media',[_c('img',{attrs:{"src":item.image,"alt":"Produto"}})]),_vm._v(" "),_c('md-card-header',[_c('md-card-header-text',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(item.productGroup)+" / "+_vm._s(item.productSubgroup))])])],1),_vm._v(" "),_c('md-card-content',[_c('p',[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(item.description))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Estoque:")]),_vm._v(" "+_vm._s(item.stockStatus)+" / "),_c('strong',[_vm._v("Preço:")]),_vm._v(" R$ "+_vm._s(item.appPrice)+" ")]),_vm._v(" "),_c('md-card-actions',[_c('div',{staticClass:"MarcaPecaProdutoHolder"},[_c('img',{staticClass:"MarcaPecaProduto",attrs:{"src":item.marcaPecaProduto,"alt":"MarcaPecaProduto"}})]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.GetProdInfo(item)}}},[_c('md-icon',[_vm._v("info")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.$root.AddProd(item)}}},[_c('md-icon',[_vm._v("add_shopping_cart")])],1)],1)],1)],1)],1)],1)}))]),_vm._v(" "),_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-icon":"collections"},on:{"click":function($event){_vm.$root.produtos.detalhe.menuTitle = 'Imagens';}}},_vm._l((_vm.$root.produtos.detalhe.images),function(item){return _c('div',{staticStyle:{"display":"inline-block"}},[_c('img',{staticStyle:{"max-height":"300px"},attrs:{"src":item.caminho,"alt":"Imagem"}})])}))],1),_vm._v(" "),_c('md-dialog-actions',{staticStyle:{"min-width":"270px","width":"calc(100% - 10px;)"}},[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.CloseInfoProd()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{staticStyle:{"max-width":"100px","max-height":"220px"},attrs:{"md-active":_vm.$root.carrinho.inputQtd.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.carrinho.inputQtd, "visible", $event)}}},[_c('md-tabs',{attrs:{"md-dynamic-height":""}},[_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-label":"Adicionar produto"}},[_c('div',{staticClass:"md-title"},[_vm._v("Estoque Disponível: "+_vm._s(_vm.$root.carrinho.inputQtd.item.stock))]),_vm._v(" "),_c('div',{attrs:{"id":"fieldQtd"}},[_c('md-button',{on:{"click":function($event){_vm.$root.RmvQtd1()}}},[_c('md-icon',[_vm._v("remove_circle")])],1),_vm._v(" "),_c('h1',[_c('strong',[_vm._v(_vm._s(_vm.$root.carrinho.inputQtd.qtd))])]),_vm._v(" "),_c('md-button',{on:{"click":function($event){_vm.$root.AddQtd1()}}},[_c('md-icon',[_vm._v("add_circle")])],1)],1)])],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.ConfirmAddProd()}}},[_vm._v("Confirmar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.CancelAddProd()}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{staticStyle:{"max-width":"100px","max-height":"220px"},attrs:{"md-active":_vm.$root.carrinho.editQtd.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.carrinho.editQtd, "visible", $event)}}},[_c('md-tabs',{attrs:{"md-dynamic-height":""}},[_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-label":"Editar produto"}},[_c('div',{staticClass:"md-title"},[_vm._v("Estoque Disponível: "+_vm._s(_vm.$root.carrinho.editQtd.item.stock))]),_vm._v(" "),_c('div',{attrs:{"id":"fieldQtd"}},[_c('md-button',{on:{"click":function($event){_vm.$root.RmvQtd2()}}},[_c('md-icon',[_vm._v("remove_circle")])],1),_vm._v(" "),_c('h1',[_c('strong',[_vm._v(_vm._s(_vm.$root.carrinho.editQtd.qtd))])]),_vm._v(" "),_c('md-button',{on:{"click":function($event){_vm.$root.AddQtd2()}}},[_c('md-icon',[_vm._v("add_circle")])],1)],1)])],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.ConfirmEditProd()}}},[_vm._v("Confirmar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.CancelEditProd()}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.carrinho.detalhe.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.carrinho.detalhe, "visible", $event)}}},[_c('md-dialog-title',[_vm._v("Resumo do Pedido")]),_vm._v(" "),_c('md-tabs',{attrs:{"md-dynamic-height":""}},[_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-label":"Dados"}},[_c('p',[_c('strong',[_vm._v("Empresa: ")]),_vm._v(" "+_vm._s(_vm.$root.user.company))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Cliente: ")]),_vm._v(" "+_vm._s(_vm.$root.user.cnpj))]),_vm._v(" "),_c('md-divider'),_vm._v(" "),_vm._l((_vm.$root.carrinho.itens),function(item){return _c('div',[_c('p',[_c('strong',[_vm._v("Produto: ")]),_vm._v(" "+_vm._s(item.code)+" - "+_vm._s(item.description)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Qtd: ")]),_vm._v(" "+_vm._s(item.appQtd)+" "+_vm._s(item.unity)+" x R$ "+_vm._s(item.appPrice)+" = R$ "+_vm._s((item.appTotalPrice)))])])}),_vm._v(" "),_c('md-divider'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_c('strong',[_vm._v("TOTAL R$: "+_vm._s(_vm.$root.carrinho.detalhe.total))])])],2)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.SendOrder()}}},[_vm._v("Concluir")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.CloseInfoCarrinho()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.pedidos.detalhe.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.pedidos.detalhe, "visible", $event)}}},[_c('md-dialog-title',[_vm._v("Detalhes")]),_vm._v(" "),_c('md-tabs',{attrs:{"md-dynamic-height":""}},[_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-label":"Resumo"}},[_c('p',[_c('strong',[_vm._v("Empresa:")]),_vm._v(" "+_vm._s(_vm.$root.pedidos.detalhe.item.company))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Solicitação Nº:")]),_vm._v(" "+_vm._s(_vm.$root.pedidos.detalhe.item.solicitationNumber))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Pedido Nº:")]),_vm._v(" "+_vm._s(_vm.$root.pedidos.detalhe.item.orderNumber)+" / "),_c('strong',[_vm._v("Situação:")]),_vm._v(" "+_vm._s(_vm.$root.pedidos.detalhe.item.status))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Data do Pedido:")]),_vm._v(" "+_vm._s(_vm.$root.pedidos.detalhe.item.orderDate))]),_vm._v(" "),_c('md-divider'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_c('strong',[_vm._v("Valor do Pedido Solicitado: R$ "+_vm._s(_vm.$root.pedidos.detalhe.item.appTotalPrice))])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_c('strong',[_vm._v("Valor do Pedido Aprovado: R$ "+_vm._s(_vm.$root.pedidos.detalhe.item.totalPrice))])])],1),_vm._v(" "),_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-label":"Itens do Pedido - Solicitado"}},[_vm._l((_vm.$root.pedidos.detalhe.item.itens),function(item){return _c('div',[_c('p',[_c('strong',[_vm._v("Produto:")]),_vm._v(" "+_vm._s(item.code)+" - "+_vm._s(item.description)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Qtd: ")]),_vm._v(" "+_vm._s(item.appQtd)+" "+_vm._s(item.unity)+" x R$ "+_vm._s(item.appPrice)+" = R$ "+_vm._s(item.appTotalPrice))])])}),_vm._v(" "),_c('md-divider'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_c('strong',[_vm._v("TOTAL: R$ "+_vm._s(_vm.$root.pedidos.detalhe.item.appTotalPrice))])])],2),_vm._v(" "),_c('md-tab',{staticClass:"infoSizeLimit",attrs:{"md-label":"Itens do Pedido - Aprovado"}},[_vm._l((_vm.$root.pedidos.detalhe.item.itens),function(item){return _c('div',[_c('p',[_c('strong',[_vm._v("Produto:")]),_vm._v(" "+_vm._s(item.code)+" - "+_vm._s(item.description)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Qtd: ")]),_vm._v(" "+_vm._s(item.qtd)+" "+_vm._s(item.unity)+" x R$ "+_vm._s(item.price)+" = R$ "+_vm._s(item.totalPrice))])])}),_vm._v(" "),_c('md-divider'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_c('strong',[_vm._v("TOTAL: R$ "+_vm._s(_vm.$root.pedidos.detalhe.item.totalPrice))])])],2)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.CancelOrder(_vm.$root.pedidos.detalhe.item)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.CloseOrderInfo()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.pedidos.pesquisa.visible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.pedidos.pesquisa, "visible", $event)}}},[_c('md-dialog-title',[_vm._v("Pesquisar Pedidos")]),_vm._v(" "),_c('md-dialog-content',[_c('md-field',[_c('md-icon',[_vm._v("event")]),_vm._v(" "),_c('label',[_vm._v("Data Inicial")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],model:{value:(_vm.$root.pedidos.pesquisa.initialDateSrc),callback:function ($$v) {_vm.$set(_vm.$root.pedidos.pesquisa, "initialDateSrc", $$v)},expression:"$root.pedidos.pesquisa.initialDateSrc"}})],1),_vm._v(" "),_c('md-field',[_c('md-icon',[_vm._v("event")]),_vm._v(" "),_c('label',[_vm._v("Data Final")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],model:{value:(_vm.$root.pedidos.pesquisa.finalDateSrc),callback:function ($$v) {_vm.$set(_vm.$root.pedidos.pesquisa, "finalDateSrc", $$v)},expression:"$root.pedidos.pesquisa.finalDateSrc"}})],1),_vm._v(" "),_c('md-field',[_c('label',{attrs:{"for":"statusSel"}},[_vm._v("Status")]),_vm._v(" "),_c('md-select',{attrs:{"name":"statusSel","id":"statusSel","multiple":""},model:{value:(_vm.$root.pedidos.pesquisa.statusSrc),callback:function ($$v) {_vm.$set(_vm.$root.pedidos.pesquisa, "statusSrc", $$v)},expression:"$root.pedidos.pesquisa.statusSrc"}},_vm._l((_vm.$root.pedidos.pesquisa.status),function(item){return _c('md-option',{attrs:{"value":item.statusId}},[_vm._v(_vm._s(item.description))])}))],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.SearchOrders()}}},[_vm._v("Buscar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.CloseOrderSearch()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.global.recuperaSenhaVisible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.global, "recuperaSenhaVisible", $event)}}},[_c('md-dialog-title',[_vm._v("Recuperação de Senha")]),_vm._v(" "),_c('md-dialog-content',[_c('md-field',{attrs:{"id":"fieldCNPJ"}},[_c('label',{attrs:{"for":"cnpj"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('md-input',{attrs:{"name":"cnpj","id":"cnpj","autocomplete":"given-cnpj","disabled":_vm.$root.global.sending},model:{value:(_vm.$root.user.cnpj),callback:function ($$v) {_vm.$set(_vm.$root.user, "cnpj", $$v)},expression:"$root.user.cnpj"}})],1),_vm._v(" "),_c('md-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.login.validId),expression:"$root.login.validId"}],attrs:{"id":"fieldEmpresas"}},[_c('label',{attrs:{"for":"company"}},[_vm._v("Empresas")]),_vm._v(" "),_c('md-select',{attrs:{"name":"company","md-dense":"","disabled":_vm.$root.global.sending},model:{value:(_vm.$root.user.company),callback:function ($$v) {_vm.$set(_vm.$root.user, "company", $$v)},expression:"$root.user.company"}},_vm._l((_vm.$root.login.companies),function(comp){return _c('md-option',{attrs:{"value":comp.companyCnpj}},[_vm._v(_vm._s(comp.companyName1))])}))],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("Email de Recuperação")]),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.RecuperarSenha()}},model:{value:(_vm.$root.user.email),callback:function ($$v) {_vm.$set(_vm.$root.user, "email", $$v)},expression:"$root.user.email"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.validateUser()}}},[_vm._v("BUSCAR")]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.login.validId),expression:"$root.login.validId"}],staticClass:"md-primary",on:{"click":function($event){_vm.$root.RecuperarSenha()}}},[_vm._v("ENVIAR")])],1)],1)],1),_vm._v(" "),_c('div',[_c('md-dialog',{attrs:{"md-active":_vm.$root.global.alteraSenhaVisible},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.global, "alteraSenhaVisible", $event)}}},[_c('md-dialog-title',[_vm._v("Alteração de Senha")]),_vm._v(" "),_c('md-dialog-content',[_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"},attrs:{"for":"password"}},[_vm._v("Senha atual")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},model:{value:(_vm.$root.user.password),callback:function ($$v) {_vm.$set(_vm.$root.user, "password", $$v)},expression:"$root.user.password"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"},attrs:{"for":"password"}},[_vm._v("Nova senha")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},model:{value:(_vm.$root.user.newPassword),callback:function ($$v) {_vm.$set(_vm.$root.user, "newPassword", $$v)},expression:"$root.user.newPassword"}})],1),_vm._v(" "),_c('md-field',[_c('label',{staticStyle:{"font-size":"12px"},attrs:{"for":"password"}},[_vm._v("Confirmar nova senha")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.$root.AlterarSenha()}},model:{value:(_vm.$root.user.confirmNewPassword),callback:function ($$v) {_vm.$set(_vm.$root.user, "confirmNewPassword", $$v)},expression:"$root.user.confirmNewPassword"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$root.AlterarSenha()}}},[_vm._v("ALTERAR")])],1)],1)],1),_vm._v(" "),_c('md-dialog-alert',{attrs:{"md-active":_vm.$root.global.dialogVisible,"md-content":_vm.$root.global.dialogMessage,"md-confirm-text":"FECHAR"},on:{"update:mdActive":function($event){_vm.$set(_vm.$root.global, "dialogVisible", $event)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.update.updating),expression:"$root.update.updating"}],staticClass:"md-overlay md-fixed"},[_c('md-progress-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.update.updating),expression:"$root.update.updating"}],staticClass:"centralize",attrs:{"md-diameter":100,"md-stroke":10,"md-mode":"indeterminate"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(10);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'App',
    component: __WEBPACK_IMPORTED_MODULE_2__App_vue__["default"]
  }]
}));

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[12]);


// WEBPACK FOOTER //
// static/js/app.3ad1b3c97d409f2d9e37.js